var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deployments", attrs: { id: "deployments" } },
    [
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _vm.metrics.length > 0
          ? _c(
              "div",
              { staticClass: "card metrics-card" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.name))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-container" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.downloadYearlyCSV()
                          }
                        }
                      },
                      [_vm._v("Download Report")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.lastUpdate
                    ? _c(
                        "div",
                        { staticClass: "col last-update text-center" },
                        [
                          _c("strong", [_vm._v("Updated:")]),
                          _vm._v(
                            " " + _vm._s(_vm.showLastUpdate(_vm.lastUpdate))
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "transition-group",
                  { staticClass: "chart", attrs: { name: "list", appear: "" } },
                  [
                    _vm._l(_vm.metrics, function(metric, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: index,
                            staticClass: "bar",
                            class: [
                              {
                                active:
                                  (metric.date || metric.deploy.date) ===
                                  _vm.date
                              }
                            ],
                            style: {
                              height: _vm.barHeight(metric, _vm.metrics) + "%"
                            },
                            on: {
                              click: function($event) {
                                return _vm.setDate(metric, index)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "labels" }, [
                              _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(metric[_vm.metricProperty]) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.formatLabel(metric.label)) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bafa860", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bafa860","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeploymentsGraph.vue
// module id = null
// module chunks = 